import classNames from "classnames";
import React from "react";

import { Link } from "../common/Link";
import { IFormHelpLink } from "../models/formFields";
import { FormFieldWrapper } from "./FormFieldWrapper";
import { getDescribedByElemID } from "./hooks/formUtils";

export const FormHelpLink = (props: IFormHelpLink): React.ReactNode => {
    const helpTextClasses = classNames({
        "form__help-text": true,
        [props.helpTextClass || ""]: !!props.helpTextClass,
    });

    return (
        <FormFieldWrapper {...props}>
            <p
                className={helpTextClasses}
                id={props.id ? getDescribedByElemID(props.id) : undefined}
            >
                <Link href={props.href} target={props.target || "_top"}>
                    {props.helpText}
                </Link>
            </p>
        </FormFieldWrapper>
    );
};
